import {Component, inject} from '@angular/core';
import {MapComponent} from '../map.component';
import {CampaignUserStatus, LoyaltyCurrencyPipe, UserLocationService} from 'shared-lib';
import { GoogleMap, MapAdvancedMarker} from '@angular/google-maps';
import { MapMarkerDetailsCarouselComponent } from '../map-marker-details-carousel/map-marker-details-carousel.component';
import { NgStyle } from '@angular/common';
import {LocationsWithLoyaltyStore, LocationsWithoutLoyaltyStore} from '../../../store/my-places-map.store';

@Component({
    selector: 'app-locations-without-loyalty-map',
    templateUrl: '../map.component.html',
    styleUrl: '../map.component.scss',
    imports: [GoogleMap, MapAdvancedMarker, MapMarkerDetailsCarouselComponent, NgStyle]
})
export class LocationsWithoutLoyaltyMapComponent extends MapComponent {
  private locationsWithoutLoyaltyStore = inject(LocationsWithoutLoyaltyStore);

  constructor(currencyPipe: LoyaltyCurrencyPipe, userLocationService: UserLocationService) {
    super(currencyPipe, userLocationService, CampaignUserStatus.ACTIVE)
  }

  protected override getStore = () => this.locationsWithoutLoyaltyStore;
}

